/** Format a meter value into km/mi/nmi/m. */
export function formatDistance(
  meters: number | null | undefined,
  unit: 'km' | 'mi' | 'nmi' | 'm' = 'km',
): string {
  if (!meters) return '0';
  if (unit === 'km') return (meters / 1000).toFixed(1);
  if (unit === 'mi') return (meters / 1609.344).toFixed(1);
  if (unit === 'nmi') return (meters / 1852).toFixed(1);
  return meters.toFixed(0);
}
